<div #editingBoxWrapper id="editingBoxWrapper">
  <div class="filters lease-term-filters associated">
    <ng-container *ngFor="let column of reportSection">
      <div [class]="column.field">
        <div class="user-filter-label">
          <label class="filter-label"> {{ column.header }}</label>
        </div>
        <miq-uom-record-detail-inputs
          *ngIf="column.unit; else singleField"
          [recordDetail]="column"
          [record]="record"
          [module]="'reports'"
          (rdChange)="onUomChange($event, reportSection)"
        >
        </miq-uom-record-detail-inputs>
        <ng-template #singleField>
          <miq-editing-box-field
            [record]="record"
            [column]="column"
            [readColumnValue]="column.value"
            (modified)="onColumnValChange($event, reportSection)"
          ></miq-editing-box-field>
        </ng-template>
      </div>
    </ng-container>
  </div>
  <div *ngIf="errorMsg" class="alert-msg"><mat-icon svgIcon="warning-icon"></mat-icon> {{ errorMsg }}</div>
  <div class="lease-term-row">
    <a (click)="applyLeaseTermCalc()">Apply</a>
  </div>
</div>
